import React, { useState, useEffect } from "react";
import {
  Container,
  Card,
  Table,
  Button,
  Row,
  Col,
  InputGroup,
  FormControl,
  Spinner,
  Badge,
  Modal,
  Form,
} from "react-bootstrap";

import Layout from "../../layout/Layout";

import {
  getExportOrderList,
  insertExportOrder,
  updateExportOrder,
  deleteExportOrder,
} from "../../../api/disticaret/orderApi";

import {
  getCustomers,
  insertCustomer,
} from "../../../api/disticaret/customerApi";

// --- DİL SÖZLÜĞÜ (TRANSLATIONS) ---
const dict = {
  TR: {
    pageTitle: "İhracat Siparişleri",
    pageSubtitle: "Siparişleri yönetin ve detayları inceleyin.",
    searchPlaceholder: "Proforma, PO veya Kota Ara...",
    createOrderBtn: "+ Yeni Sipariş",
    colCustomer: "Müşteri",
    colProforma: "Proforma / PO",
    colStatus: "Durum",
    colCurrency: "Döviz",
    colPaymentTerm: "Ödeme / Teslim",
    colFinancials: "Finans (Top. / Kalan)",
    colActions: "İşlemler",
    loadingText: "Yükleniyor...",
    noOrderFound: "Sipariş bulunamadı.",
    days: "Gün",
    btnEdit: "Düzenle / Detay",
    btnDelete: "Sil",
    deleteConfirm: "nolu siparişi silmek istediğinize emin misiniz?",
    deleteSuccess: "Silme işlemi başarılı.",
    deleteError: "Silme işlemi başarısız oldu.",
    fetchError: "Sipariş listesi alınamadı.",
    mandotaryFields: "Müşteri ve Proforma No zorunludur.",
    saveError: "Sipariş kaydedilirken hata oluştu.",
    modalCreateTitle: "Yeni Sipariş Oluştur",
    modalUpdateTitle: "Siparişi Güncelle",
    lblCustomer: "Müşteri",
    selectCustomer: "Müşteri Seçin...",
    btnAdd: "+ Ekle",
    lblProformaNo: "Proforma No",
    lblPoNo: "PO No",
    lblStatus: "Durum",
    lblCurrency: "Para Birimi",
    lblPaymentTerm: "Ödeme Vadesi (Gün)",
    lblIncoterm: "Teslim Şekli (Incoterm)",
    lblTotalAmount: "Toplam Tutar",
    lblPrepaymentAmount: "Alınan Ön Ödeme",
    lblQuotaInfo: "Kota Bilgisi",
    lblImportTracking: "İthalat Takibi",
    lblNote: "Genel Not",
    btnCancel: "İptal",
    btnSaveOrder: "Siparişi Kaydet",
    modalCustomerTitle: "Yeni Müşteri Ekle",
    lblCompanyName: "Şirket Adı",
    lblRegion: "Bölge",
    lblSector: "Sektör",
    btnSaveCustomer: "Müşteriyi Kaydet",
    customerMandatory: "Şirket adı zorunludur.",
    customerAddError: "Müşteri eklenemedi.",
    statusPlanning: "Planlanıyor",
    statusProduction: "Üretimde",
    statusCompleted: "Tamamlandı",

    itemsTitle: "Sipariş Kalemleri (Ürünler)",
    btnAddItem: "+ Kalem Ekle",
    thGoods: "Goods",
    thDimension: "Dimension",
    thTons: "Tons",
    thQuality: "Quality",
    thShipment: "Shipment",
    thDelivery: "Delivery",
    thRawMaterial: "Raw Material",
    thSource: "Source",
    thRaw: "Raw Cost",
    thProd: "Prod. Cost",
    thShipCost: "Ship. Cost",
    thTax: "Tax",
    thMat: "Maturity",
    thStatus: "Durum",
    thRemove: "Sil",
  },
  EN: {
    pageTitle: "Export Orders",
    pageSubtitle: "Manage your orders and view details.",
    searchPlaceholder: "Search Proforma, PO or Quota...",
    createOrderBtn: "+ Create Order",
    colCustomer: "Customer",
    colProforma: "Proforma / PO",
    colStatus: "Status",
    colCurrency: "Currency",
    colPaymentTerm: "Payment / Term",
    colFinancials: "Finance (Tot. / Rem.)",
    colActions: "Actions",
    loadingText: "Loading...",
    noOrderFound: "No orders found.",
    days: "Days",
    btnEdit: "Edit / Detail",
    btnDelete: "Delete",
    deleteConfirm: "Are you sure you want to delete order number",
    deleteSuccess: "Deleted successfully.",
    deleteError: "Delete operation failed.",
    fetchError: "Could not fetch order list.",
    mandotaryFields: "Customer and Proforma No are mandatory.",
    saveError: "Error occurred while saving the order.",
    modalCreateTitle: "Create New Order",
    modalUpdateTitle: "Update Order",
    lblCustomer: "Customer",
    selectCustomer: "Select Customer...",
    btnAdd: "+ Add",
    lblProformaNo: "Proforma No",
    lblPoNo: "PO No",
    lblStatus: "Status",
    lblCurrency: "Currency",
    lblPaymentTerm: "Payment Term (Days)",
    lblIncoterm: "Incoterm",
    lblTotalAmount: "Total Amount",
    lblPrepaymentAmount: "Prepayment Amount",
    lblQuotaInfo: "Quota Info",
    lblImportTracking: "Import Tracking",
    lblNote: "General Note",
    btnCancel: "Cancel",
    btnSaveOrder: "Save Order",
    modalCustomerTitle: "Add New Customer",
    lblCompanyName: "Company Name",
    lblRegion: "Region",
    lblSector: "Sector",
    btnSaveCustomer: "Save Customer",
    customerMandatory: "Company name is mandatory.",
    customerAddError: "Could not add customer.",
    statusPlanning: "Planning",
    statusProduction: "Production",
    statusCompleted: "Completed",

    itemsTitle: "Order Items (Products)",
    btnAddItem: "+ Add Item",
    thGoods: "Goods",
    thDimension: "Dimension",
    thTons: "Tons",
    thQuality: "Quality",
    thShipment: "Shipment",
    thDelivery: "Delivery",
    thRawMaterial: "Raw Material",
    thSource: "Source",
    thRaw: "Raw Cost",
    thProd: "Prod. Cost",
    thShipCost: "Ship. Cost",
    thTax: "Tax",
    thMat: "Maturity",
    thStatus: "Status",
    thRemove: "Del",
  },
};

export default function ExportOrderListPage() {
  const [lang, setLang] = useState("EN");
  const t = dict[lang];

  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");

  const [customers, setCustomers] = useState([]);

  const [showOrderModal, setShowOrderModal] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [savingOrder, setSavingOrder] = useState(false);

  const [orderForm, setOrderForm] = useState({
    _id: "",
    customerId: "",
    proformaNo: "",
    poNo: "",
    currency: "USD",
    paymentTerm: "",
    incoterm: "",
    totalAmount: "",
    prepaymentAmount: "",
    quotaInfo: "",
    importTracking: "",
    status: "planning",
    note: "",
    items: [],
  });

  const [showCustomerModal, setShowCustomerModal] = useState(false);
  const [savingCustomer, setSavingCustomer] = useState(false);
  const [customerForm, setCustomerForm] = useState({
    companyName: "",
    region: "",
    sector: "",
  });

  const fetchOrders = async () => {
    setLoading(true);
    try {
      const response = await getExportOrderList({});
      if (response.data?.success || response.data?.statusCode === 200) {
        const data = response.data.data?.items || response.data.data || [];
        setOrders(data);
      } else {
        alert(t.fetchError);
      }
    } catch (error) {
      console.error("Siparis listesi cekme hatasi", error);
    } finally {
      setLoading(false);
    }
  };

  const fetchCustomersList = async () => {
    try {
      const response = await getCustomers();
      if (response.data?.success || response.data?.statusCode === 200) {
        setCustomers(response.data.data);
      }
    } catch (error) {
      console.error("Musteri listesi cekilemedi", error);
    }
  };

  useEffect(() => {
    fetchOrders();
    fetchCustomersList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleOpenCreateOrder = () => {
    setIsEditing(false);
    setOrderForm({
      _id: "",
      customerId: "",
      proformaNo: "",
      poNo: "",
      currency: "USD",
      paymentTerm: "",
      incoterm: "",
      totalAmount: "",
      prepaymentAmount: "",
      quotaInfo: "",
      importTracking: "",
      status: "planning",
      note: "",
      items: [],
    });
    setShowOrderModal(true);
  };

  const handleOpenEditOrder = (order) => {
    setIsEditing(true);
    setOrderForm({
      _id: order._id,
      customerId: order.customerId?._id || order.customerId || "",
      proformaNo: order.proformaNo || "",
      poNo: order.poNo || "",
      currency: order.currency || "USD",
      paymentTerm: order.paymentTerm ? String(order.paymentTerm) : "",
      incoterm: order.incoterm || "",
      totalAmount: order.totalAmount ? String(order.totalAmount) : "",
      prepaymentAmount: order.prepaymentAmount
        ? String(order.prepaymentAmount)
        : "",
      quotaInfo: order.quotaInfo || "",
      importTracking: order.importTracking || "",
      status: order.status || "planning",
      note: order.note || "",
      items: order.items || [],
    });
    setShowOrderModal(true);
  };

  const handleOrderChange = (e) => {
    setOrderForm({ ...orderForm, [e.target.name]: e.target.value });
  };

  const handleAddItem = () => {
    setOrderForm({
      ...orderForm,
      items: [
        ...orderForm.items,
        {
          goods: "",
          dimension: "",
          tons: "",
          quality: "",
          shipment: "",
          delivery: "",
          rawMaterial: "",
          source: "",
          rawCost: "",
          productionCost: "",
          shipmentCost: "",
          tax: "",
          maturity: "",
          status: "uretilmedi",
          note: "",
        },
      ],
    });
  };

  const handleRemoveItem = (index) => {
    const newItems = [...orderForm.items];
    newItems.splice(index, 1);
    setOrderForm({ ...orderForm, items: newItems });
  };

  const handleItemChange = (index, field, value) => {
    const newItems = [...orderForm.items];
    newItems[index][field] = value;
    setOrderForm({ ...orderForm, items: newItems });
  };

  const handleSaveOrder = async (e) => {
    e.preventDefault();
    if (!orderForm.customerId || !orderForm.proformaNo) {
      alert(t.mandotaryFields);
      return;
    }

    setSavingOrder(true);
    try {
      const payload = { ...orderForm };

      if (payload.paymentTerm)
        payload.paymentTerm = Number(payload.paymentTerm);
      else delete payload.paymentTerm;

      if (payload.totalAmount)
        payload.totalAmount = Number(payload.totalAmount);
      else payload.totalAmount = 0;

      if (payload.prepaymentAmount)
        payload.prepaymentAmount = Number(payload.prepaymentAmount);
      else payload.prepaymentAmount = 0;

      if (!payload.poNo) delete payload.poNo;
      if (!payload.incoterm) delete payload.incoterm;
      if (!payload.quotaInfo) delete payload.quotaInfo;
      if (!payload.importTracking) delete payload.importTracking;
      if (!payload.note) delete payload.note;

      payload.items = payload.items.map((item) => {
        return {
          ...item,
          tons: Number(item.tons) || undefined,
          rawCost: Number(item.rawCost) || undefined,
          productionCost: Number(item.productionCost) || undefined,
          shipmentCost: Number(item.shipmentCost) || undefined,
          tax: Number(item.tax) || undefined,
          maturity: Number(item.maturity) || undefined,
        };
      });

      let response;
      if (isEditing) {
        response = await updateExportOrder(payload);
      } else {
        delete payload._id;
        response = await insertExportOrder(payload);
      }

      if (response.data?.success || response.data?.statusCode === 200) {
        setShowOrderModal(false);
        fetchOrders();
      } else {
        alert(t.saveError);
      }
    } catch (error) {
      console.error("Siparis kayit hatasi", error);
    } finally {
      setSavingOrder(false);
    }
  };

  const handleDeleteOrder = async (id, proformaNo) => {
    if (!window.confirm(`${t.deleteConfirm} ${proformaNo}?`)) return;
    try {
      const response = await deleteExportOrder({ id });
      if (response.data?.success || response.data?.statusCode === 200) {
        fetchOrders();
      } else {
        alert(t.deleteError);
      }
    } catch (error) {
      console.error("Siparis silme hatasi", error);
    }
  };

  const handleCustomerChange = (e) => {
    setCustomerForm({ ...customerForm, [e.target.name]: e.target.value });
  };

  const handleSaveCustomer = async () => {
    if (!customerForm.companyName) return alert(t.customerMandatory);
    setSavingCustomer(true);
    try {
      const response = await insertCustomer(customerForm);
      if (response.data?.success || response.data?.statusCode === 200) {
        setShowCustomerModal(false);
        setCustomerForm({ companyName: "", region: "", sector: "" });
        await fetchCustomersList();
      } else {
        alert(t.customerAddError);
      }
    } catch (error) {
      console.error("Musteri kayit hatasi", error);
    } finally {
      setSavingCustomer(false);
    }
  };

  const filteredOrders = orders.filter((order) => {
    const custName = order.customerId?.companyName?.toLowerCase() || "";
    const prof = order.proformaNo?.toLowerCase() || "";
    const po = order.poNo?.toLowerCase() || "";
    const search = searchTerm.toLowerCase();
    return (
      custName.includes(search) || prof.includes(search) || po.includes(search)
    );
  });

  const translateStatus = (statusKey) => {
    if (statusKey === "planning") return t.statusPlanning;
    if (statusKey === "production") return t.statusProduction;
    if (statusKey === "completed") return t.statusCompleted;
    return statusKey;
  };

  return (
    <Layout>
      {/* CSS: Modal'ı %95 genişliğe zorlayan stil */}
      <style type="text/css">
        {`
          .custom-wide-modal {
            max-width: 95vw !important;
          }
        `}
      </style>

      <Container
        fluid
        className="py-5 px-lg-5"
        style={{ backgroundColor: "#F3F4F6", minHeight: "100vh" }}
      >
        <Row className="align-items-center mb-4">
          <Col md={6} className="d-flex align-items-center gap-3">
            <div>
              <h3 className="fw-bold text-dark mb-1">{t.pageTitle}</h3>
              <p className="text-muted small mb-0">{t.pageSubtitle}</p>
            </div>
            <div className="bg-white rounded p-1 shadow-sm d-flex ms-3">
              <Button
                variant={lang === "TR" ? "primary" : "light"}
                size="sm"
                className="fw-bold border-0 px-2 py-1"
                onClick={() => setLang("TR")}
              >
                TR
              </Button>
              <Button
                variant={lang === "EN" ? "primary" : "light"}
                size="sm"
                className="fw-bold border-0 px-2 py-1"
                onClick={() => setLang("EN")}
              >
                EN
              </Button>
            </div>
          </Col>
          <Col
            md={6}
            className="d-flex justify-content-md-end gap-3 mt-3 mt-md-0"
          >
            <InputGroup className="shadow-sm" style={{ maxWidth: "260px" }}>
              <FormControl
                placeholder={t.searchPlaceholder}
                className="border-0 text-muted"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </InputGroup>
            <Button
              variant="primary"
              className="fw-semibold shadow-sm px-4"
              onClick={handleOpenCreateOrder}
            >
              {t.createOrderBtn}
            </Button>
          </Col>
        </Row>

        <Card
          className="border-0 shadow-sm"
          style={{ borderRadius: "12px", overflow: "hidden" }}
        >
          <Table hover responsive className="mb-0 align-middle">
            <thead className="bg-light">
              <tr>
                <th className="py-3 ps-4 text-secondary small fw-bold border-bottom-0">
                  {t.colCustomer}
                </th>
                <th className="py-3 text-secondary small fw-bold border-bottom-0">
                  {t.colProforma}
                </th>
                <th className="py-3 text-secondary small fw-bold border-bottom-0">
                  {t.colStatus}
                </th>
                <th className="py-3 text-secondary small fw-bold border-bottom-0">
                  {t.colCurrency}
                </th>
                <th className="py-3 text-secondary small fw-bold border-bottom-0">
                  {t.colPaymentTerm}
                </th>
                <th className="py-3 text-secondary small fw-bold border-bottom-0">
                  {t.colFinancials}
                </th>
                <th className="py-3 text-end pe-4 text-secondary small fw-bold border-bottom-0">
                  {t.colActions}
                </th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr>
                  <td colSpan="7" className="text-center py-5">
                    <Spinner animation="border" variant="primary" />
                  </td>
                </tr>
              ) : filteredOrders.length > 0 ? (
                filteredOrders.map((order) => {
                  const orderId = order._id;

                  let badgeColor = "secondary";
                  if (order.status === "completed") badgeColor = "success";
                  else if (order.status === "production")
                    badgeColor = "warning";

                  const total = order.totalAmount || 0;
                  const pre = order.prepaymentAmount || 0;
                  const rem = total - pre;

                  return (
                    <tr key={orderId}>
                      <td className="ps-4 py-3 fw-bold text-dark">
                        {order.customerId?.companyName || "Unknown"}
                      </td>
                      <td className="py-3">
                        <div className="fw-semibold text-dark">
                          {order.proformaNo}
                        </div>
                        <div className="text-muted small">
                          PO: {order.poNo || "-"}
                        </div>
                      </td>
                      <td className="py-3">
                        <Badge bg={badgeColor} className="text-uppercase">
                          {translateStatus(order.status || "planning")}
                        </Badge>
                      </td>
                      <td className="py-3">
                        <Badge bg="secondary">{order.currency || "USD"}</Badge>
                      </td>
                      <td className="py-3 small">
                        <div className="text-dark">{order.incoterm || "-"}</div>
                        <div className="text-muted">
                          {order.paymentTerm
                            ? `${order.paymentTerm} ${t.days}`
                            : "-"}
                        </div>
                      </td>
                      <td className="py-3 small">
                        <div className="text-dark fw-semibold">
                          {total.toLocaleString()} {order.currency}
                        </div>
                        <div className="text-danger">
                          Kalan: {rem.toLocaleString()} {order.currency}
                        </div>
                      </td>
                      <td className="text-end pe-4 py-3">
                        <Button
                          variant="light"
                          size="sm"
                          className="me-2 text-primary fw-semibold border-0"
                          onClick={() => handleOpenEditOrder(order)}
                        >
                          {t.btnEdit}
                        </Button>
                        <Button
                          variant="light"
                          size="sm"
                          className="text-danger fw-semibold border-0"
                          onClick={() =>
                            handleDeleteOrder(orderId, order.proformaNo)
                          }
                        >
                          {t.btnDelete}
                        </Button>
                      </td>
                    </tr>
                  );
                })
              ) : (
                <tr>
                  <td colSpan="7" className="text-center py-5 text-muted">
                    {t.noOrderFound}
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        </Card>
      </Container>

      {/* CREATE/UPDATE ORDER MODAL */}
      <Modal
        show={showOrderModal}
        onHide={() => setShowOrderModal(false)}
        dialogClassName="custom-wide-modal" /* GÜNCELLENDİ: Özel genişlik sınıfı eklendi */
        centered
        backdrop="static"
      >
        <Modal.Header closeButton className="border-0 pb-0 pt-4 ps-4">
          <Modal.Title className="fw-bold">
            {isEditing ? t.modalUpdateTitle : t.modalCreateTitle}
          </Modal.Title>
        </Modal.Header>
        <Form onSubmit={handleSaveOrder}>
          <Modal.Body
            className="p-4"
            style={{ maxHeight: "75vh", overflowY: "auto" }}
          >
            {/* ÜST KISIM: SİPARİŞ GENEL BİLGİLERİ */}
            <Row>
              <Col md={4}>
                <Form.Group className="mb-3">
                  <Form.Label className="small fw-semibold text-secondary">
                    {t.lblCustomer}
                  </Form.Label>
                  <div className="d-flex gap-2">
                    <Form.Select
                      name="customerId"
                      value={orderForm.customerId}
                      onChange={handleOrderChange}
                    >
                      <option value="">{t.selectCustomer}</option>
                      {customers.map((c) => (
                        <option key={c._id || c.id} value={c._id || c.id}>
                          {c.companyName}
                        </option>
                      ))}
                    </Form.Select>
                    <Button
                      variant="outline-primary"
                      style={{ whiteSpace: "nowrap" }}
                      onClick={() => setShowCustomerModal(true)}
                    >
                      {t.btnAdd}
                    </Button>
                  </div>
                </Form.Group>
              </Col>
              <Col md={3}>
                <Form.Group className="mb-3">
                  <Form.Label className="small fw-semibold text-secondary">
                    {t.lblProformaNo}
                  </Form.Label>
                  <Form.Control
                    type="text"
                    name="proformaNo"
                    value={orderForm.proformaNo}
                    onChange={handleOrderChange}
                    required
                  />
                </Form.Group>
              </Col>
              <Col md={2}>
                <Form.Group className="mb-3">
                  <Form.Label className="small fw-semibold text-secondary">
                    {t.lblPoNo}
                  </Form.Label>
                  <Form.Control
                    type="text"
                    name="poNo"
                    value={orderForm.poNo}
                    onChange={handleOrderChange}
                  />
                </Form.Group>
              </Col>
              <Col md={3}>
                <Form.Group className="mb-3">
                  <Form.Label className="small fw-semibold text-secondary">
                    {t.lblStatus}
                  </Form.Label>
                  <Form.Select
                    name="status"
                    value={orderForm.status}
                    onChange={handleOrderChange}
                  >
                    <option value="planning">{t.statusPlanning}</option>
                    <option value="production">{t.statusProduction}</option>
                    <option value="completed">{t.statusCompleted}</option>
                  </Form.Select>
                </Form.Group>
              </Col>
            </Row>

            <Row>
              <Col md={2}>
                <Form.Group className="mb-3">
                  <Form.Label className="small fw-semibold text-secondary">
                    {t.lblCurrency}
                  </Form.Label>
                  <Form.Select
                    name="currency"
                    value={orderForm.currency}
                    onChange={handleOrderChange}
                  >
                    <option value="USD">USD</option>
                    <option value="EUR">EUR</option>
                    <option value="GBP">GBP</option>
                  </Form.Select>
                </Form.Group>
              </Col>
              <Col md={2}>
                <Form.Group className="mb-3">
                  <Form.Label className="small fw-semibold text-secondary">
                    {t.lblPaymentTerm}
                  </Form.Label>
                  <Form.Control
                    type="number"
                    name="paymentTerm"
                    value={orderForm.paymentTerm}
                    onChange={handleOrderChange}
                  />
                </Form.Group>
              </Col>
              <Col md={2}>
                <Form.Group className="mb-3">
                  <Form.Label className="small fw-semibold text-secondary">
                    {t.lblIncoterm}
                  </Form.Label>
                  <Form.Select
                    name="incoterm"
                    value={orderForm.incoterm}
                    onChange={handleOrderChange}
                  >
                    <option value="">Seçiniz...</option>
                    <option value="EXW">EXW</option>
                    <option value="FOB">FOB</option>
                    <option value="CIF">CIF</option>
                    <option value="DAP">DAP</option>
                    <option value="DDP">DDP</option>
                  </Form.Select>
                </Form.Group>
              </Col>
              <Col md={3}>
                <Form.Group className="mb-3">
                  <Form.Label className="small fw-semibold text-secondary">
                    {t.lblTotalAmount}
                  </Form.Label>
                  <Form.Control
                    type="number"
                    name="totalAmount"
                    value={orderForm.totalAmount}
                    onChange={handleOrderChange}
                  />
                </Form.Group>
              </Col>
              <Col md={3}>
                <Form.Group className="mb-3">
                  <Form.Label className="small fw-semibold text-secondary">
                    {t.lblPrepaymentAmount}
                  </Form.Label>
                  <Form.Control
                    type="number"
                    name="prepaymentAmount"
                    value={orderForm.prepaymentAmount}
                    onChange={handleOrderChange}
                  />
                </Form.Group>
              </Col>
            </Row>

            <Row>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label className="small fw-semibold text-secondary">
                    {t.lblQuotaInfo}
                  </Form.Label>
                  <Form.Control
                    type="text"
                    name="quotaInfo"
                    placeholder="Örn: Kotaya uygun, %25 vergi vs."
                    value={orderForm.quotaInfo}
                    onChange={handleOrderChange}
                  />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label className="small fw-semibold text-secondary">
                    {t.lblImportTracking}
                  </Form.Label>
                  <Form.Control
                    type="text"
                    name="importTracking"
                    placeholder="Örn: Gemi yolda, ETA 15 Nisan"
                    value={orderForm.importTracking}
                    onChange={handleOrderChange}
                  />
                </Form.Group>
              </Col>
            </Row>

            <hr />

            {/* ALT KISIM: SİPARİŞ KALEMLERİ (EXCEL TABLOSU GİBİ) */}
            <div className="d-flex justify-content-between align-items-center mb-3">
              <h5 className="fw-bold mb-0 text-dark">{t.itemsTitle}</h5>
              <Button variant="success" size="sm" onClick={handleAddItem}>
                {t.btnAddItem}
              </Button>
            </div>

            <div className="table-responsive">
              {/* GÜNCELLENDİ: minWidth 1500px yapıldı ki geniş kolonlar rahatça sığsın */}
              <Table bordered hover size="sm" style={{ minWidth: "1500px" }}>
                <thead className="bg-light">
                  <tr>
                    <th style={{ width: "120px" }}>{t.thGoods}</th>
                    <th style={{ width: "140px" }}>{t.thDimension}</th>
                    <th style={{ width: "80px" }}>{t.thTons}</th>
                    <th style={{ width: "100px" }}>{t.thQuality}</th>
                    <th style={{ width: "120px" }}>{t.thShipment}</th>
                    <th style={{ width: "120px" }}>{t.thDelivery}</th>
                    <th style={{ width: "140px" }}>{t.thRawMaterial}</th>
                    <th style={{ width: "110px" }}>{t.thSource}</th>
                    <th style={{ width: "100px" }}>{t.thRaw}</th>
                    <th style={{ width: "100px" }}>{t.thProd}</th>
                    <th style={{ width: "100px" }}>{t.thShipCost}</th>
                    <th style={{ width: "100px" }}>{t.thTax}</th>
                    <th style={{ width: "100px" }}>{t.thMat}</th>
                    <th style={{ width: "120px" }}>{t.thStatus}</th>
                    <th style={{ width: "60px", textAlign: "center" }}>
                      {t.thRemove}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {orderForm.items.length === 0 ? (
                    <tr>
                      <td colSpan="15" className="text-center text-muted py-3">
                        Eklenmiş kalem yok. "+ Kalem Ekle" butonuna basın.
                      </td>
                    </tr>
                  ) : (
                    orderForm.items.map((item, idx) => (
                      <tr key={idx}>
                        <td>
                          <Form.Control
                            size="sm"
                            type="text"
                            value={item.goods}
                            onChange={(e) =>
                              handleItemChange(idx, "goods", e.target.value)
                            }
                          />
                        </td>
                        <td>
                          <Form.Control
                            size="sm"
                            type="text"
                            value={item.dimension}
                            onChange={(e) =>
                              handleItemChange(idx, "dimension", e.target.value)
                            }
                          />
                        </td>
                        <td>
                          <Form.Control
                            size="sm"
                            type="number"
                            value={item.tons}
                            onChange={(e) =>
                              handleItemChange(idx, "tons", e.target.value)
                            }
                          />
                        </td>
                        <td>
                          <Form.Control
                            size="sm"
                            type="text"
                            value={item.quality}
                            onChange={(e) =>
                              handleItemChange(idx, "quality", e.target.value)
                            }
                          />
                        </td>
                        <td>
                          <Form.Control
                            size="sm"
                            type="text"
                            placeholder="MID OF FEB"
                            value={item.shipment}
                            onChange={(e) =>
                              handleItemChange(idx, "shipment", e.target.value)
                            }
                          />
                        </td>
                        <td>
                          <Form.Control
                            size="sm"
                            type="text"
                            placeholder="MAY"
                            value={item.delivery}
                            onChange={(e) =>
                              handleItemChange(idx, "delivery", e.target.value)
                            }
                          />
                        </td>
                        <td>
                          <Form.Control
                            size="sm"
                            type="text"
                            placeholder="1.23 RAW"
                            value={item.rawMaterial}
                            onChange={(e) =>
                              handleItemChange(
                                idx,
                                "rawMaterial",
                                e.target.value
                              )
                            }
                          />
                        </td>
                        <td>
                          <Form.Control
                            size="sm"
                            type="text"
                            placeholder="YILDIZ"
                            value={item.source}
                            onChange={(e) =>
                              handleItemChange(idx, "source", e.target.value)
                            }
                          />
                        </td>
                        <td>
                          <Form.Control
                            size="sm"
                            type="number"
                            value={item.rawCost}
                            onChange={(e) =>
                              handleItemChange(idx, "rawCost", e.target.value)
                            }
                          />
                        </td>
                        <td>
                          <Form.Control
                            size="sm"
                            type="number"
                            value={item.productionCost}
                            onChange={(e) =>
                              handleItemChange(
                                idx,
                                "productionCost",
                                e.target.value
                              )
                            }
                          />
                        </td>
                        <td>
                          <Form.Control
                            size="sm"
                            type="number"
                            value={item.shipmentCost}
                            onChange={(e) =>
                              handleItemChange(
                                idx,
                                "shipmentCost",
                                e.target.value
                              )
                            }
                          />
                        </td>
                        <td>
                          <Form.Control
                            size="sm"
                            type="number"
                            value={item.tax}
                            onChange={(e) =>
                              handleItemChange(idx, "tax", e.target.value)
                            }
                          />
                        </td>
                        <td>
                          <Form.Control
                            size="sm"
                            type="number"
                            value={item.maturity}
                            onChange={(e) =>
                              handleItemChange(idx, "maturity", e.target.value)
                            }
                          />
                        </td>
                        <td>
                          <Form.Select
                            size="sm"
                            value={item.status}
                            onChange={(e) =>
                              handleItemChange(idx, "status", e.target.value)
                            }
                          >
                            <option value="uretilmedi">Üretilmedi</option>
                            <option value="uretiliyor">Üretiliyor</option>
                            <option value="tamamlandi">Tamamlandı</option>
                          </Form.Select>
                        </td>
                        <td className="text-center align-middle">
                          <Button
                            variant="outline-danger"
                            size="sm"
                            className="border-0 p-1"
                            onClick={() => handleRemoveItem(idx)}
                          >
                            X
                          </Button>
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </Table>
            </div>
          </Modal.Body>
          <Modal.Footer className="border-0 pb-4 pe-4 pt-3">
            <Button variant="light" onClick={() => setShowOrderModal(false)}>
              {t.btnCancel}
            </Button>
            <Button variant="primary" type="submit" disabled={savingOrder}>
              {savingOrder ? (
                <Spinner size="sm" animation="border" />
              ) : (
                t.btnSaveOrder
              )}
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>

      {/* ADD CUSTOMER MODAL */}
      <Modal
        show={showCustomerModal}
        onHide={() => setShowCustomerModal(false)}
        centered
      >
        <Modal.Header closeButton className="border-0 pb-0 pt-4 ps-4">
          <Modal.Title className="fw-bold fs-5">
            {t.modalCustomerTitle}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-4">
          <Form.Group className="mb-3">
            <Form.Label className="small fw-semibold text-secondary">
              {t.lblCompanyName}
            </Form.Label>
            <Form.Control
              type="text"
              name="companyName"
              value={customerForm.companyName}
              onChange={handleCustomerChange}
            />
          </Form.Group>
          <Row>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label className="small fw-semibold text-secondary">
                  {t.lblRegion}
                </Form.Label>
                <Form.Control
                  type="text"
                  name="region"
                  value={customerForm.region}
                  onChange={handleCustomerChange}
                />
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label className="small fw-semibold text-secondary">
                  {t.lblSector}
                </Form.Label>
                <Form.Control
                  type="text"
                  name="sector"
                  value={customerForm.sector}
                  onChange={handleCustomerChange}
                />
              </Form.Group>
            </Col>
          </Row>
        </Modal.Body>
        <Modal.Footer className="border-0 pb-4 pe-4">
          <Button variant="light" onClick={() => setShowCustomerModal(false)}>
            {t.btnCancel}
          </Button>
          <Button
            variant="primary"
            onClick={handleSaveCustomer}
            disabled={savingCustomer}
          >
            {t.btnSaveCustomer}
          </Button>
        </Modal.Footer>
      </Modal>
    </Layout>
  );
}
